export const setCurrentCompanie = (idCompanie: number) => {
  localStorage.setItem("currentCompanie", JSON.stringify(idCompanie));
};

export const getCurrentCompanie = () => {
  return JSON.parse(localStorage.getItem("currentCompanie") || "0");
};

export const getCurrentCompanieId = () => {
  const currentuser = JSON.parse(
    localStorage.getItem("currentUser") ?? "{}"
  ) as TUser;
  return currentuser?.company_users?.[0]?.company_id;
};

/**
 * True only for an ACTIVE super-admin, matching the API Gate
 * (`ONLY_SUPER_ADMIN` requires `isSuperAdmin() && is_active == 1`).
 *
 * BUGFIX: this used to read `Number(company_users[0].company_role) === 1`.
 * `company_role` is a string enum ("FLEET_MANAGER" / "EMPLOYEE"), so
 * `Number(...)` was always NaN and the function always returned false - and it
 * was inspecting a company membership rather than the platform-level
 * `is_super_admin` flag in the first place.
 *
 * Prefer `useAuth().can(...)` in components; this remains for non-React call
 * sites.
 */
export const isCurrentUserSuperAdmin = (): boolean => {
  try {
    const currentUser = JSON.parse(
      localStorage.getItem("currentUser") ?? "{}"
    ) as { is_super_admin?: number; is_active?: number };
    return (
      Number(currentUser?.is_super_admin) === 1 &&
      Number(currentUser?.is_active) === 1
    );
  } catch {
    return false;
  }
};
